import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  type ErrorComponentProps,
  Link,
  Outlet,
} from "@tanstack/react-router";
import { Toaster } from "sonner";
import { Button } from "@/components/ui/button";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: ({ error, reset }: ErrorComponentProps) => (
    <main className="mx-auto grid min-h-dvh max-w-md place-content-center gap-4 px-6 text-center">
      <h1 className="text-xl">Страница не загрузилась</h1>
      <p className="text-muted">{error instanceof Error ? error.message : String(error)}</p>
      <Button onClick={reset}>Попробовать снова</Button>
    </main>
  ),
});

function Root() {
  return (
    <>
      <Outlet />
      <Toaster
        position="top-center"
        toastOptions={{
          classNames: {
            toast: "!bg-surface !text-text !border-line !rounded-xl !font-sans",
            description: "!text-muted",
          },
        }}
      />
    </>
  );
}

function NotFound() {
  return (
    <main className="mx-auto grid min-h-dvh max-w-md place-content-center gap-4 px-6 text-center">
      <h1 className="text-xl">Такой страницы нет</h1>
      <Button asChild variant="secondary">
        <Link to="/">На главную</Link>
      </Button>
    </main>
  );
}
